<template lang="html">
  <v-dialog v-model="showModal" :max-width="listaFluxoApuracao.length ? '1600' : '800'">
        <v-card>
          <v-container class="bg-surface-variant" fluid>
            <v-row>
              <v-col :cols="listaFluxoApuracao.length ? '6' : '12'" class="pa-3">
                <v-card outlined class="fill-height pa-2">
                  <v-card-title class="pr-0 pt-2">
                    <span class="headline pr-0">
                      {{ tituloAcompanhamentoCampanha }}
                      <v-tooltip bottom nudge-top="10">
                        <template v-slot:activator="{ on }">
                          <v-btn text icon v-on="on">
                            <v-icon>info</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ fluxo && fluxo.cabecalhoFluxo ? fluxo.cabecalhoFluxo.descricao : '' }}</span>
                      </v-tooltip>
                    </span>
                  </v-card-title>
                  <v-row class="pl-6">
                    <v-col cols="12" class="d-flex flex-column justify-end align-end pr-10">
                      <v-btn color="primary" small @click.native="exportarHistoricoAprovacao(dadosModalAcompanhamento.idAcao, entidadeAcao.toLowerCase())">
                        {{ $t('label.historico_de_aprovacoes') }}
                        <v-icon small>download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-card-text class="px-0">
                    <v-timeline dense class="mx-3 my-1 pt-0">
                      <v-timeline-item
                          :color="colorPalette[0]"
                          fill-dot
                          small
                          right
                          v-if="fluxo.cabecalhoFluxo">
                        <v-card class="elevation-2">
                          <v-card-title class="title historico_header px-3 pt-2 pb-0">{{$t('title.descricao_dados_acompanhamento_campanha', {idAcao: dadosModalAcompanhamento.idAcao, modalidade: formataTextoModalidade(dadosModalAcompanhamento.modalidade)})}}</v-card-title>
                          <v-card-title class="title historico_header px-3 pt-0">{{$t('label.solicitado_por') + ' ' + fluxo.cabecalhoFluxo.usuarioSolicitante.nome + ' '
                            + fluxo.cabecalhoFluxo.usuarioSolicitante.sobrenome}}</v-card-title>
                          <v-card-text>
                            <v-row
                              v-if="fluxo && fluxo.cabecalhoFluxo && fluxo.cabecalhoFluxo.observacaoAcao"
                              class="px-3 py-2">
                              <span><b class="pr-1">{{$t('label.justificativa')}}:</b></span>
                              <span>{{ fluxo.cabecalhoFluxo.observacaoAcao }}</span>
                            </v-row>
                            <v-col class="px-3 pt-0 pl-0">
                              <div v-if="dadosModalAcompanhamento && dadosModalAcompanhamento.numNotaDebito">
                                <span><b class="pr-1">{{$tc('title.nota_debito', 1)}}:</b>: {{formatarValoresNotaDebito(dadosModalAcompanhamento.numNotaDebito)}}</span>
                                <v-btn
                                  v-if="visualizaIconeModalNotaDebito(countNotasDebitoCampanha(dadosModalAcompanhamento.numNotaDebito))"
                                  icon class="mx-0" @click.native="visualizarNotasDebito(dadosModalAcompanhamento)">
                                  <v-icon>visibility</v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                            <v-row class="px-3 py-2">
                                <span><b class="pr-1">{{$t('label.data_solicitacao')}}:</b></span>
                                <span>{{toDate(fluxo.cabecalhoFluxo.dtaSolicitacao)}}</span>
                                <span><b class="pl-6">{{$tc('label.perfil', 1)}}:</b></span>
                                <span class="pl-1">{{fluxo.cabecalhoFluxo.usuarioSolicitante.nomePerfil}}</span>
                            </v-row>
                            <v-row
                              v-if="fluxo && fluxo.cabecalhoFluxo && fluxo.cabecalhoFluxo.observacaoAcao"
                              class="px-3 py-2">
                              <span><b class="pr-1">{{$t('label.justificativa')}}:</b></span>
                              <span>{{ fluxo.cabecalhoFluxo.observacaoAcao }}</span>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-timeline-item>
                        <v-timeline-item
                          v-for="(item, index) in fluxo.passos"
                          :color="item.isPassoBloqueado ? 'grey' : styles(item.statusPasso)" fill-dot small right
                          v-if="exibePasso(item)" :key="index">
                        <template slot="icon">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on" style="cursor: default;"></span>
                            </template>
                            <span>
                              {{$tc(`status_entidade.${item.statusPasso.toLowerCase()}`, 1)}}
                            </span>
                          </v-tooltip>
                        </template>
                        <acompanhamento-item
                            :item="item"
                            :cliente="fluxo.cliente"
                            :entidade="entidade"
                            :id-entidade="fluxo.idEntidade">
                        </acompanhamento-item>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="6" v-if="listaFluxoApuracao.length" class="pl-0">
                <v-card outlined class="fill-height pa-2">
                  <v-card-title class="pt-2 pb-4">
                    <span class="headline">{{ tituloAcompanhamentoApuracao }}</span>
                  </v-card-title>

                  <v-expansion-panels accordion>
                    <v-expansion-panel v-for="(item, index) in listaFluxoApuracao" :key="index">

                      <v-expansion-panel-header class="font-weight-bold subtitle-1">
                        <div>
                          {{ `${$tc('label.parcial', 1)} #${item.indiceApuracao}` }}
                          <span v-if="item.dtaInicioVigencia && item.dtaFimVigencia">
                            - {{ formatDate(item.dtaInicioVigencia) }} à {{ formatDate(item.dtaFimVigencia) }}
                          </span>
                          <span v-if="item.cabecalhoFluxo.statusFluxo">
                            - {{ formatarStatus(item.cabecalhoFluxo.statusFluxo) }}
                          </span>
                        </div>
                        <v-tooltip bottom nudge-top="10">
                          <template v-slot:activator="{ on }">
                            <v-btn text icon v-on="on" class="ml-2 mt-n1" style="height: 24px; width: 24px;">
                              <v-icon>info</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ item.cabecalhoFluxo.descricao }}</span>
                        </v-tooltip>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-card class="elevation-0">

                          <v-row class="pl-4 pb-2">
                            <v-col cols="7" class="pl-4 pr-0">
                              <div v-if="item.numNotaDebito">
                                <span>{{$t('label.nds')}}: {{formatarValoresNotaDebito(item.numNotaDebito)}}</span>
                                <v-btn
                                  v-if="visualizaIconeModalNotaDebito(item.countNotasDebito)"
                                  icon class="mx-0" @click.native="visualizarNotasDebito(item)">
                                  <v-icon>visibility</v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                            <v-col cols="5" class="d-flex justify-end pr-6">
                              <v-btn color="primary" small @click.native="exportarHistoricoAprovacao(item.idEntidade, entidadeApuracao.toLowerCase())">
                                {{ $t('label.historico_de_aprovacoes') }}
                                <v-icon small>download</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-card-text class="pb-0 px-0">
                            <v-timeline dense class="mx-1 my-1 pt-0">
                              <v-timeline-item :color="colorPalette[0]" fill-dot small right v-if="item.cabecalhoFluxo">
                                <v-card class="elevation-2">
                                  <v-card-title class="title historico_header px-3 pt-2 pb-0">
                                    {{$t('title.descricao_dados_acompanhamento_campanha', {idAcao: item.idAcao, modalidade: formataTextoModalidade(item.modalidade)})}}
                                  </v-card-title>

                                  <v-card-title class="title historico_header px-3 pt-0">
                                    {{$t('label.solicitado_por') + ' ' + item.cabecalhoFluxo.usuarioSolicitante.nome + ' ' + item.cabecalhoFluxo.usuarioSolicitante.sobrenome}}
                                  </v-card-title>

                                  <v-card-text>
                                  <v-row class="px-3 pt-2">
                                    <span><b class="pr-1">{{$tc('label.data_emissao', 1)}}:</b></span>
                                    <span>{{item.dtaEmissao}}</span>
                                  </v-row>
                                    <v-row class="px-3 py-2">
                                      <span><b class="pr-1">{{$t('label.data_solicitacao')}}:</b></span>
                                      <span>{{toDate(item.cabecalhoFluxo.dtaSolicitacao)}}</span>
                                      <span><b class="pl-6">{{$tc('label.perfil', 1)}}:</b></span>
                                      <span class="pl-1">{{item.cabecalhoFluxo.usuarioSolicitante.nomePerfil}}</span>
                                    </v-row>
                                    <v-row v-if="item && item.cabecalhoFluxo && item.cabecalhoFluxo.observacaoAcao" class="px-3 py-2">
                                      <span><b class="pr-1">{{$t('label.justificativa')}}:</b></span>
                                      <span>{{ item.cabecalhoFluxo.observacaoAcao }}</span>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-timeline-item>

                              <v-timeline-item v-for="(passo, index) in item.passos" :color="styles(passo.statusPasso)"
                              fill-dot small right v-if="exibePasso(passo)" :key="index">
                                <template slot="icon">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on" style="cursor: default;"></span>
                                    </template>
                                    <span>{{$tc(`status_entidade.${passo.statusPasso.toLowerCase()}`, 1)}}</span>
                                  </v-tooltip>
                                </template>
                                <acompanhamento-item :item="passo" :cliente="item.cliente" :entidade="entidadeApuracao"
                                :id-entidade="item.idEntidade"></acompanhamento-item>
                              </v-timeline-item>

                            </v-timeline>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>
              </v-col>
              <v-col cols="12" class=" text--darken-2 pl-6" v-if="dadosModalAcompanhamento && dadosModalAcompanhamento.dtaCriacao">
                {{ $t('label.campanha_criada_por', {
                    usuarioCriacao: dadosModalAcompanhamento.nomeUsuarioCriacao,
                    dtaCriacao: formatDate(dadosModalAcompanhamento.dtaCriacao)
                }) }}
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click.native="fechar">{{ $t('label.fechar') }}</v-btn>
          </v-card-actions>
        </v-card>
        <modal-nota-debito
        ref="modalNotaDebito">
        </modal-nota-debito>

        <apuracao-acao-lista-modal-gerar-nd
          ref="modalGerarNd"
          v-if="acaoModal"
          v-model="acaoModal"
          :abrir-modal="abrirModalND"
          :ocultaResumo="true"
          @ApuracaoAcaoListaModalGerarNd__fechar="fecharModalND">
        </apuracao-acao-lista-modal-gerar-nd>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { removeEmptyProperties } from '@/common/functions/helpers';
import exportacao from '@/common/functions/exportacao';
import ModalNotaDebito from '@/spa/apuracao-acao/ModalNotaDebito';
import ApuracaoAcaoListaModalGerarNd from '@/spa/apuracao-acao/ApuracaoAcaoListaModalGerarNd';
import { countExportacaoHistoricoAprovacao } from '@/common/resources/magalu-relatorios';
import moment from 'moment';
import AcompanhamentoItem from './AcompanhamentoItem';

export default {
  name: 'AcompanhamentoAcaoApuracao',
  data() {
    return {
      showModal: false,
      countNotasExibicao: 4,
      tituloAcompanhamentoApuracao: `${this.$t('label.acompanhamento_fluxo')} - ${this.$t('label.apuracao_de_acao')}`,
      tituloAcompanhamentoCampanha: `${this.$t('label.acompanhamento_fluxo')} - ${this.$t('title.planejamento_de_campanha')}`,
      entidadeApuracao: 'APURACAO',
      entidadeAcao: 'ACAO',
      currentIndex: 2,
      acaoModal: null,
      abrirModalND: false,
      colorPalette: [
        'teal accent-4', // Verde
        'red lighten-1', // Vermelho
        'orange darken-2', // Laranja
        'amber lighten-1', // Amarelo
        'blue-grey lighten-2', // Cinza
        'blue darken-1', // Azul
      ],
    };
  },
  props: {
    fluxo: Object,
    dadosModalAcompanhamento: Object,
    listaFluxoApuracao: Array,
    entidade: String,
  },
  components: {
    AcompanhamentoItem,
    ModalNotaDebito,
    ApuracaoAcaoListaModalGerarNd,
  },
  computed: {
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    isApuracao() {
      return this.entidade === 'APURACAO';
    },
    isAmbienteMagalu() {
      return this.chaveEmpresa === 'MAGALU';
    },
    exibeDataEmissao() {
      return this.isAmbienteMagalu && this.dadosModalAcompanhamento && this.dadosModalAcompanhamento.emissao;
    },
  },
  methods: {
    open() {
      this.showModal = true;
      this.currentIndex = 0;
    },
    fechar() {
      this.$emit('resetaCampos');
      this.showModal = false;
    },
    toDate(data) {
      const formatos = ['DD/MM/YYYY HH:mm:ss', moment.ISO_8601];
      return this.moment(data, formatos, true).format('DD-MM-YYYY HH:mm:ss');
    },
    formatDate(data) {
      const formatos = ['DD/MM/YYYY HH:mm:ss', moment.ISO_8601];
      return this.moment(data, formatos, true).format('DD-MM-YYYY');
    },
    exibePasso(passo) {
      return passo.statusPasso !== 'CONDICAO_NAO_ATENDIDA' && passo.statusPasso !== 'TRANSFERIDO';
    },
    styles(status) {
      let colorIndex = 0;
      if (status === 'ENCERRADO') {
        colorIndex = 5;
      } else if (status === 'EM_CADASTRO') {
        colorIndex = 4;
      } else if (status === 'EM_FLUXO') {
        colorIndex = 4;
      } else if (status === 'CANCELADO') {
        colorIndex = 3;
      } else if (status === 'AGUARDANDO_APROVACAO') {
        colorIndex = 2;
      } else if (status === 'REPROVADO') {
        colorIndex = 1;
      } else if (status === 'AGUARDANDO_EXECUCAO_METAS') {
        colorIndex = 6;
      } else if (status === 'AGUARDANDO_APURACAO') {
        colorIndex = 5;
      } else if (status === 'AGUARDANDO_PAGAMENTO') {
        colorIndex = 5;
      } else if (status === 'APURACAO_PREVIA') {
        colorIndex = 4;
      } else if (status === 'EM_ANALISE') {
        colorIndex = 3;
      } else if (status === 'EM_REIVINDICACAO') {
        colorIndex = 2;
      } else {
        colorIndex = 0;
      }

      return this.color || this.colorPalette[colorIndex];
    },
    visualizaIconeModalNotaDebito(countNotasDebito) {
      return countNotasDebito > this.countNotasExibicao;
    },
    visualizarNotasDebito(item) {
      setTimeout(() => this.$refs.modalNotaDebito.open(item), 2E2);
    },
    formatarValoresNotaDebito(numNotaDebito) {
      const numNotas = numNotaDebito.split(',');
      if (numNotas.length > this.countNotasExibicao) {
        return `${numNotas.slice(0, 4).join(',')}...`;
      }
      return numNotaDebito;
    },
    countNotasDebitoCampanha(numNotaDebito) {
      const numNotas = numNotaDebito.split(',');
      return numNotas.length;
    },
    formatarStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replaceAll('_', ' ');
    },
    formataTextoModalidade(modalidade) {
      let modalidadeFormatada = null;
      if (modalidade === 'SELLIN') {
        modalidadeFormatada = this.$t('label.sellin');
      } else if (modalidade === 'SELLOUT') {
        modalidadeFormatada = this.$t('label.sellout');
      } else if (modalidade === 'FATURAMENTO_FORNECEDOR') {
        modalidadeFormatada = this.$t('label.faturamento_fornecedor');
      } else if (modalidade === 'VALOR_FIXO') {
        modalidadeFormatada = this.$t('label.valor_fixo');
      }
      return modalidadeFormatada;
    },
    exportarHistoricoAprovacao(idEntidade, nomeEntidade) {
      const params = {
        idEntidade,
        nomeEntidade,
      };
      let quantidadeRegistros = 0;

      countExportacaoHistoricoAprovacao(params, this.$resource)
        .then((response) => {
          quantidadeRegistros = response.data;
          if (quantidadeRegistros > 0) {
            if (nomeEntidade === this.entidadeAcao.toLowerCase()) {
              params.id_acao = idEntidade;
            } else {
              params.id_apuracao = idEntidade;
            }
            this.requestExportacao(params, 'historico_fluxo_aprovacao', 'api');
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestExportacao(params, tipoRelatorio, modulo = 'api') {
      const filtroTratado = removeEmptyProperties(params);
      this.bloquearExportacao = true;

      exportacao.exportar(() => {
        this.bloquearExportacao = false;
      }, tipoRelatorio, this, filtroTratado, 5000, 0, modulo);
    },
    getCollorIcon(acao) {
      if (acao.emissao && acao.emissao.calculo_bonificacao === 'VALOR_FIXO') {
        return acao.emissao.status_acao === 'APROVADO' ? '#1abc9c' : '#95a5a6';
      }
      if (acao.emissao && acao.emissao.status_apuracao) {
        return acao.emissao.status_apuracao === 'APROVADO' ? '#1abc9c' : '#95a5a6';
      }
      return '#95a5a6';
    },
    abrirModalGerarNd(acao) {
      this.acaoModal = acao;
      this.acaoModal.cod_acao = acao.idAcao;
      setTimeout(() => { this.abrirModalND = true; }, 2E2);
    },
    fecharModalND() {
      this.abrirModalND = false;
      setTimeout(() => { this.acaoModal = null; }, 2E2);
    },
  },
  mounted() {
  },
};
</script>
